import './assets/typography.css';
import { jsx as m } from "react/jsx-runtime";
import T from "clsx";
import { DEFAULT_VARIANT as i, DEFAULT_COLOR as l, DEFAULT_COLOR_SHADE as E, DEFAULT_WEIGHT as _ } from "./utils.js";
import { forwardRefPolymorphic as d } from "./utils.polymorphic.js";
const g = "_typography_6ocfq_3", L = {
  typography: g
}, A = "span", o = (r, a) => {
  const {
    as: t,
    children: p,
    className: s,
    variant: n = i,
    color: c = l,
    colorShade: y = E,
    weight: e = _,
    ...h
  } = r;
  return /* @__PURE__ */ m(
    t ?? A,
    {
      ...h,
      ref: a,
      className: T(L.typography, s),
      "data-variant": n,
      "data-color": c,
      "data-color-shade": y,
      "data-weight": e,
      children: p
    }
  );
};
o.displayName = "Typography";
const C = d(o);
export {
  C as Typography
};
